import React, { FC } from "react";
import { Box, Typography } from "@mui/material";

interface CircularGaugeProps {
  value: number;
  size?: number;
  strokeWidth?: number;
}

const CircularGauge: FC<CircularGaugeProps> = ({
  value,
  size = 120,
  strokeWidth = 8
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const normalizedValue = Math.min(Math.max(value, -100), 100);
  // Clamp between -100 and 100
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (Math.abs(normalizedValue) / 100) * circumference;

  const color = normalizedValue === 0 ? '#4caf50' : normalizedValue > 0 ? '#f44336' : '#2196f3';

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Box position="relative" display="inline-block">
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="#e0e0e0"
            strokeWidth={strokeWidth}
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{
              transition: 'stroke-dashoffset 0.3s ease-in-out',
            }}
          />
        </svg>
        {/* Center text */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" fontWeight="bold" color={color}>
            {normalizedValue.toFixed(1)}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CircularGauge;
